// TODO(AEO): Add 2 semantic triples per section (Feature → How it works → Outcome pattern). Run the /aeo-page skill.
// TODO(AEO): Add 1–2 external credible citations per section (AAD, dermatology journals).
// TODO(AEO): Ensure each paragraph follows Feature → How it works → Outcome structure.
"use client";

/**
 * Purpose: About page body — mission/story copy, the two founder TeamMemberCards, and the
 * survey CTA.
 * Inputs: Translations from `aboutUs`; Cloudinary public ids in TEAM_IMAGES.
 * Outputs: Animated sections (fadeUp); TeamMemberCard derives its portrait alt from
 * `aboutUs.teamPortraitAlt` + `name`, so no alt is passed here.
 */
import { motion } from "framer-motion";
import { useTranslations, useLocale } from "next-intl";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import RichText from "@components/text/RichText/RichText";
import HoverGradientButton from "@components/buttons/HoverGradientButton/HoverGradientButton";
import { fadeUp } from "@lib/motion";
import { TeamMemberCard } from "@components/cards/TeamMemberCard/TeamMemberCard";
import './about.css'

const TEAM_IMAGES = {
  alexis: 'alexis_bio1_dbgeni',
  london: 'london_bio1_lukrct',
};

export default function AboutClient() {
  const t = useTranslations("aboutUs");
  const locale = useLocale();
  const router = useRouter();

  // Warm the survey route so the CTA at the bottom navigates instantly.
  useEffect(() => {
    router.prefetch(`/${locale}/survey`);
  }, [router, locale]);

  const goToSurvey = () => router.push(`/${locale}/survey`);

  return (
    <main id="about-client" className="about-main">

      {/* Section 1 — Story */}
      <div className="about-story">
        <h1>
          {t("storyTitle")}
        </h1>
        <p className="about-story-body">
          <RichText translationKey="aboutUs.storyDescription" />
        </p>
      </div>

      {/* Section 2 — Meet Our Team */}
      <div className="about-team-section">
        <motion.h2
          className="about-team-heading"
          {...fadeUp(0)}
        >
          {t('meetOurTeam')}
        </motion.h2>

        <div className="about-team-grid">
          {/* First portrait is above the fold on most viewports → priority; ids must differ */}
          <TeamMemberCard
            id="team-member-card-alexis"
            imageSrc={TEAM_IMAGES.alexis}
            name="Alexis Sophie Cavaletto"
            role="Founder & Wellness Entrepreneur"
            bioKey="aboutUs.bioAlexis"
            delay={0.1}
            priority
          />
          <TeamMemberCard
            id="team-member-card-london"
            imageSrc={TEAM_IMAGES.london}
            name="London Ariel Cavaletto"
            role="Co-founder & Tech Innovator"
            bioKey="aboutUs.bioLondon"
            delay={0.2}
          />
        </div>
      </div>

      {/* Section 3 — CTA */}
      <motion.div
        className="about-cta"
        {...fadeUp(0)}
      >
        <h2>
          {t("ctaTitle")}
        </h2>
        <p className="about-cta-body">{t("ctaSubtitle")}</p>
        <HoverGradientButton onClick={goToSurvey}>
          {t("ctaButton")}
        </HoverGradientButton>
      </motion.div>

    </main>
  );
}
